module.exports = __webpack_public_path__ + "img/retrospect-81.1d03d5ac.jpg";